import React from 'react';

function FormStepper({ steps = [], activeStep = 0 }) {
  const totalSteps = steps.length;
  const progressPercent = totalSteps > 1 ? (activeStep / (totalSteps - 1)) * 100 : 100;

  const getStepStatus = (index) => {
    if (index < activeStep) return 'completed';
    if (index === activeStep) return 'active';
    return 'upcoming';
  };

  return (
    <div className="quote-stepper mb-4" aria-label="Progreso del formulario">
      <div className="quote-stepper__track" aria-hidden="true">
        <div className="quote-stepper__track-progress" style={{ width: `${progressPercent}%` }} />
      </div>
      <div className="quote-stepper__steps" role="list">
        {steps.map((_, index) => {
          const status = getStepStatus(index);
          const isActive = status === 'active';
          const statusText =
            status === 'completed' ? 'completado' : status === 'active' ? 'en curso' : 'pendiente';

          return (
            <div
              key={`step-${index}`}
              className={`quote-step quote-step--${status}`}
              role="listitem"
              aria-current={isActive ? 'step' : undefined}
              aria-label={`${index + 1} ${statusText}`}
            >
              <div className="quote-step__indicator">
                {status === 'completed' ? (
                  <span aria-hidden="true">✓</span>
                ) : (
                  <span aria-hidden="true">{index + 1}</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FormStepper;
